module.exports = __webpack_public_path__ + "static/media/deposit.8d59b889.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/deposit.svg
// module id = 885
// module chunks = 0